module.exports = __webpack_public_path__ + "static/media/ME_wind.c268712e.mp3";